// extracted by mini-css-extract-plugin
module.exports = {"component":"Button_component__2PlCN","hasText":"Button_hasText__fcsDF","hasImage":"Button_hasImage__3w7Iw","text":"Button_text__W2iGh"};